import setupAmpSRSegmentWrapper from '@amplitude/segment-session-replay-wrapper';
import { Injectable } from '@angular/core';

import { ConfigurationService, IAmplitudeAppConfig } from '@sondermind/configuration';
import { Logger } from '@sondermind/datadog-logging';
import { SegmentService } from '@sondermind/segment';

@Injectable({
  providedIn: 'root'
})
export class AmplitudeService {
  constructor(
    private configurationService: ConfigurationService<IAmplitudeAppConfig>,
    private logger: Logger,
    private segmentService: SegmentService<Record<string, unknown>>
  ) {
  }

  init(): boolean {
    if (this.configurationService.env.app?.amplitudeDisabled) {
      this.logger.warn('Aborting Amplitude initialization because it is disabled.');
      return false;
    }

    if (!this.configurationService.env.app?.amplitudeAPIKey) {
      this.logger.warn('Aborting Amplitude initialization because of missing write key.');
      return false;
    }

    return true;
  }

  async setupSessionReplay(): Promise<boolean> {
    if (!this.init()) {
      return false;
    }

    if (!this.segmentService.analytics) {
      if (!await this.segmentService.init()) {
        this.logger.warn('Aborting Amplitude initialization due to errors in segment.');
        return false;
      }
    }

    // https://amplitude.com/docs/session-replay/session-replay-standalone-sdk#configuration
    // sample rate is between 0 and 1, "representing the fraction of sessions to have randomly selected for replay collection"
    setupAmpSRSegmentWrapper({
      segmentInstance: this.segmentService.analytics,
      amplitudeApiKey: this.configurationService.env.app.amplitudeAPIKey,
      sessionReplayOptions: {
        sampleRate: this.configurationService.env.app.sessionReplay.amplitudeSampleRate,
      },
    });

    return true;
  }
}
